export default {
  // 在绑定元素的 attribute 前
  // 或事件监听器应用前调用
  // created(el, binding, vnode, prevVnode) {
  //   console.log(1111);
  //   // 下面会介绍各个参数的细节
  // },
  // // 在元素被插入到 DOM 前调用
  // beforeMount(el, binding, vnode, prevVnode) {
  //   console.log(22222);
  // },
  // 在绑定元素的父组件
  // 及他自己的所有子节点都挂载完成后调用
  mounted(el, binding) {
    let cssText = el.style.cssText;
    // 设置字体
    if (binding.modifiers.bold) {
      cssText += `font-family:var(--y-bold-font);`;
    } else if (binding.modifiers.medium) {
      cssText += `font-family:var(--y-medium-font);`;
    } else if (binding.modifiers.price) {
      cssText += `font-family:var(--y-price-font);`;
    } else if (binding.modifiers.title) {
      cssText += `font-family:var(--y-title-font);`;
    } else {
      cssText += `font-family:var(--y-regular-font);`;
    }
    if (binding.value) {
      cssText += `font-size:${binding.value}px;`;
    }

    el.style.cssText = cssText;
  }
  // // 绑定元素的父组件更新前调用
  // beforeUpdate(el, binding, vnode, prevVnode) {
  //   console.log(4444);
  // },
  // // 在绑定元素的父组件
  // // 及他自己的所有子节点都更新后调用
  // updated(el, binding, vnode, prevVnode) {
  //   console.log(55555);
  // },
  // // 绑定元素的父组件卸载前调用
  // beforeUnmount(el, binding, vnode, prevVnode) {
  //   console.log(66666);
  // },
  // // 绑定元素的父组件卸载后调用
  // unmounted(el, binding, vnode, prevVnode) {
  //   console.log(7777);
  // }
};
